<template>
  <div class="ksm-flex ksm-impressum-page" style="background-color: #eee; padding:20px">
    <div class="ksm-flex-1" style="position:relative">
      <div v-html="htmlText" style="position:absolute; width:100%; height:100%; overflow:auto"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      htmlText: ""
    };
  },
  mounted: function() {
    const vue = this;
    this.$store.dispatch("fechtDocumentById", [1183]).then(res => {
      if (!res || !res.doc) {
        return;
      }
      // vue.htmlText = res.doc[0]._source["114_html"];
      const doc = res.doc[0];
      vue.htmlText = vue.$_getNewHtmlElement(
        doc._source["114_html"],
        null,
        doc,
        true
      ).innerHTML;
    });
  },
  methods: {}
};
</script>

<style lang="scss" >
.ksm-impressum-page {
  span.weight-bold {
    font-weight: bold;
  }
  span.slant-italic {
    font-style: italic;
  }
}
</style>


// WEBPACK FOOTER //
// Impressum.vue?0e413921